import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ChoiceCardBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== '$selected',
})<{ $selected: boolean }>(({ $selected }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 14,
  padding: '14px 16px',
  borderRadius: 12,
  cursor: 'pointer',
  border: $selected
    ? '1.5px solid var(--am-accent-text)'
    : '1.5px solid var(--am-border)',
  background: $selected ? 'var(--am-accent-surface)' : 'var(--am-surface)',
  transition: 'border-color 0.14s, background 0.14s',
  '&:hover': {
    borderColor: $selected ? 'var(--am-accent-text)' : 'var(--am-border-heavy)',
  },
}));

export const ChoiceCardIcon = styled(Box)({
  width: 40,
  height: 40,
  borderRadius: 10,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 19,
  background: 'var(--am-surface)',
  border: '1px solid var(--am-border)',
});

export const ChoiceCardContent = styled(Box)({
  flex: 1,
  minWidth: 0,
});

export const ChoiceCardTitleRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
});

export const ChoiceCardTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== '$selected',
})<{ $selected: boolean }>(({ $selected }) => ({
  fontSize: '14px',
  fontWeight: 700,
  color: $selected ? 'var(--am-accent-text)' : 'var(--am-text-primary)',
}));

export const ChoiceCardBadge = styled(Box)({
  fontSize: '10px',
  fontWeight: 700,
  background: 'var(--am-accent-surface)',
  color: 'var(--am-accent-text)',
  borderRadius: 4,
  padding: '1px 6px',
  border: '1px solid var(--am-accent-text)',
});

export const ChoiceCardDesc = styled(Typography)({
  fontSize: '12px',
  color: 'var(--am-text-secondary)',
  marginTop: 2,
  lineHeight: 1.45,
}) as typeof Typography;

export const ChoiceCardRadio = styled(Box, {
  shouldForwardProp: (prop) => prop !== '$selected',
})<{ $selected: boolean }>(({ $selected }) => ({
  width: 18,
  height: 18,
  borderRadius: '50%',
  flexShrink: 0,
  border: $selected
    ? '5px solid var(--am-accent-text)'
    : '2px solid var(--am-border-mid)',
  background: 'var(--am-surface)',
  transition: 'border 0.14s',
}));
